import { useRouter } from 'next/router';
import { Col, Grid, Image, Row, Typography } from 'antd';
import { formatDateListArticels } from 'src/utils/func/format-date';

// import 'react-responsive-carousel/lib/styles/carousel.min.css';
import classes from './article.module.less';
const CardArticleHBSection1 = (props: any) => {
  const item = props;
  const {
    xs
  } = Grid.useBreakpoint();
  const router = useRouter();
  console.log(router);
  const data1 = item?.data[0];
  const dataPhase = data1?.type === 'pregnancy' ? 'kehamilan' : data1?.type === 'pre-pregnancy' ? 'pra-kehamilan' : 'pasca-kehamilan';
  return <a href={`/${dataPhase}/${data1?.slug}`}>
			<span>
				<div style={{
        // margin: 20,
        marginBottom: '35px',
        backgroundColor: '#fff',
        borderRadius: 10,
        cursor: 'pointer',
        position: 'relative',
        // Tambahkan posisi relatif
        overflow: 'hidden' // Untuk memastikan teks tidak keluar dari batas
      }}>
					<Image alt={item?.data[0]?.title} src={item?.data[0]?.media_images?.original} className={classes.imageContainer} style={{
          borderRadius: '20px',
          objectFit: 'cover',
          marginLeft: xs ? '8px' : '0px'
        }} preview={false} loading='lazy' height={xs ? '200px' : '354px'} width={xs ? '330px' : '628px'} />
					<div style={{
          position: 'absolute',
          // Posisi absolut untuk menempatkan box di atas gambar
          top: 0,
          left: 0,
          right: 0,
          bottom: 8,
          display: 'flex',
          borderRadius: 15,
          justifyContent: 'flex-start',
          paddingLeft: '10px',
          paddingBottom: '20px',
          alignItems: 'end'
        }}>
					</div>
					<div className={classes.text}>
						<Typography className={classes.category}>
							{item?.data[0]?.category_name}
						</Typography>
						<Typography style={{
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            lineHeight: 1.2,
            maxHeight: '2 em'
          }} className={classes.title}>
							{item?.data[0]?.title}
						</Typography>
						<Row>
							<Col className="d-flex align-items-center" style={{
              marginLeft: xs ? '-5px' : '-15px'
            }}>
								{!item?.data[0] ? '' : <Typography className="fs-14 fs-md-14">
										Diterbitkan pada {formatDateListArticels(item?.data[0]?.publish_date || '')}
									</Typography>}
							</Col>
						</Row>
						<Typography style={{
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            marginLeft: '-15px'
          }} className={classes.paragraph}>
							{item?.data[0]?.short_desc}
						</Typography>
					</div>
				</div>
			</span>
		</a>;
};
export default CardArticleHBSection1;